import { useQuery } from "@tanstack/react-query";
import { useAuth } from "../context/AuthContext";
import { filiaisDoClienteAtivo } from "../pages/general/homeV2Helpers";
import { CINCO_MINUTOS, repetirSoErroDeServidor } from "../utils/useApiV2";
import useAuthApi from "../utils/useAuthApi";

export default function useHomeFiliais({ enabled = true }) {
  const { getAvailableBranches } = useAuthApi();
  const { user } = useAuth();
  const filialAtiva = user?.active_branch_id ?? null;

  return useQuery({
    queryKey: ["homeFiliais", user?.user_id ?? null, filialAtiva],
    queryFn: async () =>
      filiaisDoClienteAtivo(await getAvailableBranches(), filialAtiva),
    enabled: Boolean(enabled && filialAtiva),
    staleTime: CINCO_MINUTOS,
    retry: repetirSoErroDeServidor,
  });
}
